import { Tables } from "database.types";

export const PRIORITIES = [
  "PSA",
  "BECKETT",
  "CGC",
  "SGC",
  "TAG",
  "ACE",
  "MANA",
];

export function sortGraders<T extends Array<Tables<"grading_companies">>>(
  graders: T,
): T {
  const conditionToRank = new Map<string, number>();

  PRIORITIES.forEach((condition, index) => {
    if (!conditionToRank.has(condition)) {
      conditionToRank.set(condition, index);
    }
  });

  return graders
    .map((grader, originalIndex) => ({
      grader,
      rank: conditionToRank.has(grader.id)
        ? (conditionToRank.get(grader.id) as number)
        : Number.POSITIVE_INFINITY,
      originalIndex,
    }))
    .sort((a, b) => {
      if (a.rank !== b.rank) return a.rank - b.rank;
      return a.originalIndex - b.originalIndex;
    })
    .map((entry) => entry.grader) as T;
}
